import { Component } from '@angular/core';
import { MasterDTO } from '../../model/admin.entity';
import { AdminService } from '../../services/admin.service';
import { CommonService } from '../../../core/common/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Dropdown } from 'primeng/dropdown';
import { PerformanceCriteriaDTO } from '../../model/performance-criteria.entity';
import { Utility } from '../../../core/common/services/utility.service';


@Component({
  selector: 'tandc-save-performance-criteria',
  templateUrl: './save-performance-criteria.component.html',
  styleUrls: ['./save-performance-criteria.component.scss']
})
export class SavePerformanceCriteriaComponent {

  model: PerformanceCriteriaDTO = new PerformanceCriteriaDTO();
  modalTitle: string = "";
  standardList: Dropdown[] = [];

  constructor(private service: AdminService,
    private commonService: CommonService,
    private utility: Utility,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router
  ) { }
  
  ngOnInit(): void {
    // this.modalTitle = this.translate.instant('common.update') + ' ' + this.translate.instant('Master.standard');
    const id = this.route.snapshot.paramMap.get('id');
    if (id && Number(id) > 0) {
      this.modalTitle = this.translate.instant('common.update') + ' ' + this.translate.instant('Master.performanceCriteria');
      this.service.getPerformanceCriteriaById(Number(id)).subscribe((x) => {
        this.model = x.value;
        this.getStandard();
      });
    }
    else{
      this.modalTitle = this.translate.instant('common.add') + ' ' + this.translate.instant('Master.performanceCriteria');
      this.getStandard();
    }
  }

  getStandard() {
    this.service.getStandard().subscribe(x => {
      this.standardList = Utility.reorderSelectedOnTop(
      x.value,
      this.model.standard 
      );
    });
  }

  save(data: PerformanceCriteriaDTO) {
    const isUpdate = data.id > 0;
    const msgKey = isUpdate ? 'Alerts.UpdatedSuccessfully' : 'Alerts.SavedSuccessfully';

    const saveCall = isUpdate
      ? this.service.updatePerformanceCriteria(data)
      : this.service.savePerformanceCriteria(data);

    saveCall.subscribe((res) => {
      if (res) {
        this.commonService.successMessage(this.translate.instant(msgKey));

      
        this.model.standard = data.standard;
        this.standardList = Utility.reorderSelectedOnTop(
          this.standardList,
          this.model.standard
        );
        this.router.navigate(['admin/performanceCriteria']);
      }
    });
  }


  selectedStandards(value: any) {
    let std = this.standardList.find(item => item.id == value);
    return std?.name;

  }

  delete(standard: any, model: any) {
    const index = model.standard.indexOf(standard);
    this.model.standard = this.model.standard.filter(x => x != standard);
  }


}
